const NPI_LENGTH = 10;

/** Strip non-digits and cap at 10 characters. Use as a FormField `parse` prop. */
export function maskNpiInput(raw: string): string {
  return raw.replace(/\D/g, '').slice(0, NPI_LENGTH);
}

/** Check whether a string is a valid 10-digit NPI. */
export function isValidNpi(value: string): boolean {
  return /^\d{10}$/.test(value.trim());
}
